import { DEFAULT_SUBDOMAIN } from '../../constants';
import { ResponseError } from '../../errors/ResponseError';
import {
  fetchAjaxFeedback,
  IAjaxFeedbackRequest,
  IAjaxFeedbackResponse,
  TAjaxFeedbackResponse,
} from '../../repositories/monolith-python/unversioned/ajax-feedback';
import { IApplicationContext } from '../../types/applicationContext';

export async function sendFeedback(
  { httpApi, logger }: IApplicationContext,
  parameters: IAjaxFeedbackRequest,
  subdomain: string = DEFAULT_SUBDOMAIN,
): Promise<IAjaxFeedbackResponse> {
  try {
    const { response, statusCode }: TAjaxFeedbackResponse = await fetchAjaxFeedback({
      httpApi,
      parameters,
      config: {
        subdomain,
        requestConfig: {
          headers: [['Content-Type', 'application/json']],
        },
      },
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'sendFeedback',
        message: response.message,
        details: {
          error: response.errors,
        },
      });
    }

    return response;
  } catch (error) {
    logger.warning('sendFeedback', error);

    return {} as IAjaxFeedbackResponse;
  }
}
